import { Reducer } from 'redux';

import { ThunkFailAction, ThunkSuccessAction } from '../../../services/apiMiddleware';
import { OkrLabel } from '../interfaces';
import { PaginationI } from '../../../interfaces/pagination.interface';

import { addLabelsActions, deleteLabelsActions, fetchLabelsActions } from './actionTypes';

export interface LabelSessionState {
  loadingCreation: boolean;
  loadingList: boolean;
  loadingDelete: boolean;
  list: OkrLabel[];
  pagination: PaginationI | null;
}

export function getInitialLabelSessionState(): LabelSessionState {
  return {
    list: [],
    pagination: null,
    loadingList: false,
    loadingDelete: false,
    loadingCreation: false,
  };
}

const addLabels = (action: ThunkSuccessAction | ThunkFailAction, state: LabelSessionState) => {
  if (Array.isArray(action.response.data)) {
    return { list: action.response.data };
  }
  return {
    list: action.loadMore ? [...state.list, ...action.response.data.items] : action.response.data.items,
    pagination: action.response.data.pagination,
  };
};

const deleteLabels = (state: LabelSessionState, action: ThunkSuccessAction | ThunkFailAction) =>
  state.list.filter(label => label.id !== action.labelId);

const labelReducer: Reducer<LabelSessionState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialLabelSessionState(),
  action,
) => {
  switch (action.type) {
    case fetchLabelsActions.Request:
      return { ...state, loadingList: true };
    case fetchLabelsActions.Success:
      return { ...state, loadingList: false, ...addLabels(action, state) };
    case fetchLabelsActions.Failed:
      return { ...state, loadingList: false };
    case addLabelsActions.Request:
      return { ...state, loadingCreation: true };
    case addLabelsActions.Success:
      return {
        ...state,
        loadingCreation: false,
        list: [...state.list, action.response.data],
      };
    case addLabelsActions.Failed:
      return { ...state, loadingCreation: false };
    case deleteLabelsActions.Request:
      return { ...state, loadingDelete: true };
    case deleteLabelsActions.Success:
      return {
        ...state,
        loadingDelete: false,
        loadedLabels: deleteLabels(state, action),
      };
    case deleteLabelsActions.Failed:
      return { ...state, loadingDelete: false };
    default:
      return state;
  }
};

export default labelReducer;
